import { Common, color } from "@stockbit/ui";
import styled from "styled-components";

const { Input: BaseInput } = Common;

export const EyeButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;

  img {
    width: 16px;
    height: 16px;
  }
`;

export const Input = styled(BaseInput)`
  width: 100% !important;
  &.error {
    border-color: ${color.sunsetOrange};
    &:not(.ant-input-affix-wrapper-disabled):hover {
      border-color: ${color.sunsetOrange};
    }
  }
  &:not(.ant-input-affix-wrapper-disabled):hover {
    border-color: ${color.primary};
  }
`;
